import { Component, NgModule, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ProveedoresService } from "./proveedores.service";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { Overlay } from "@angular/cdk/overlay";
import { Proveedor } from './proveedorModel';
import {MatSnackBar} from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@NgModule({
  imports: [ReactiveFormsModule]
})

@Component({
  selector: 'app-proveedores',
  templateUrl: './proveedores.component.html',
  providers: [ProveedoresService],
  styleUrls: ['./proveedores.component.scss']
})

export class ProveedoresComponent implements OnInit {

  proveedorForm = new FormGroup({
    tipoBeneficiario: new FormControl('', [Validators.required]),
    tipoCatBenef:new FormControl('', [Validators.required]),
    tipoPersona: new FormControl('', [Validators.required]),
    tipoCategTrib: new FormControl(),
    tipoDocumento: new FormControl('', [Validators.required]),
    nroDocumento: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    nombreApellido: new FormControl('', [Validators.required]),
    nombreFantasia: new FormControl(),
    nombreCheque: new FormControl('', [Validators.required]),
    sitioInternet: new FormControl(),
    codAnterior: new FormControl(),
    critico: new FormControl(),
    fechaInicioAct: new FormControl('', [Validators.required]),
    calleFiscal: new FormControl('', [Validators.required]),
    nroCasaFiscal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    dptoFiscal: new FormControl(),
    pisoFiscal: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    barrioFiscal: new FormControl('', [Validators.required]),
    ciudadFiscal: new FormControl('', [Validators.required]),
    codPostalFiscal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    provinciaFiscal: new FormControl('', [Validators.required]),
    dptoProvincialFiscal: new FormControl('', [Validators.required]),
    telefonoFiscal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(30)]),
    celularFiscal: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(30)]),
    nroLocalFiscal: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    emailFiscal: new FormControl('', [Validators.email]),
    calleReal: new FormControl('', [Validators.required]),
    nroCasaReal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    dptoReal: new FormControl(),
    pisoReal: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    barrioReal: new FormControl('', [Validators.required]),
    ciudadReal: new FormControl('', [Validators.required]),
    codPostalReal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    provinciaReal: new FormControl('', [Validators.required]),
    dptoProvincialReal: new FormControl('', [Validators.required]),
    telefonoReal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(30)]),
    celularReal: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(30)]),
    calleEspecial: new FormControl(),
    pisoEspecial: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    barrioEspecial: new FormControl(),
    codPostalEspecial: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    nroEspecial: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    dptoEspecial: new FormControl(),
    ciudadEspecial: new FormControl(),
    nombreApellidoComunicaciones: new FormControl(),
    emailComunicaciones: new FormControl('', [Validators.email]),
    cargoComunicaciones: new FormControl()
  })

  tiposPersona = [];
  tiposCatTrib = [];
  tiposDocumento = [];
  critico = [];
  rubros = [];
  provincias = [];
  departamentos1 = [];
  departamentos2 = [];
  tiposBeneficiario=[];
  tiposBeneficiarioCat=[];
  tipoBenefSelect: number;
  provinciaSelect1: number;
  provinciaSelect2: number;
  resultado;

  constructor(
    private service: ProveedoresService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {

  }

  volver(){
    this.router.navigate([`${""}`]);
  }

  ngOnInit() {
    this.critico = ['Sí', 'No'];
    this.service.getTiposPersona().subscribe(data => { this.tiposPersona = data; });
    this.service.getTiposDocumento().subscribe(data => { this.tiposDocumento = data; });
    this.service.getRubros().subscribe(data => { this.rubros = data; });
    this.service.getProvincias().subscribe(data => { this.provincias = data; });
    this.service.getTiposBenef().subscribe(data => { this.tiposBeneficiario = data});
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action);
  }

  OnSubmit() {

    if (this.proveedorForm.valid){
    this.addProveedor();
    debugger;
  }
    else
    this.openSnackBar('Todavía hay campos obligatorios por Completar','Aceptar')
  }

  cargarCategoriasBenefPago() {
    if (this.tipoBenefSelect != null)
      this.service.cargarCatBenef(this.tipoBenefSelect).subscribe(data => { this.tiposBeneficiarioCat = data })
  }

  cargarDepartamentosSelect1() {
    if (this.provinciaSelect1 != null)
      this.service.cargarDepartamentos(this.provinciaSelect1).subscribe(data => { this.departamentos1 = data })
  }

  cargarDepartamentosSelect2() {
    if (this.provinciaSelect2 != null)
      this.service.cargarDepartamentos(this.provinciaSelect2).subscribe(data => { this.departamentos2 = data })
  }

  copiarFiscal() {
    this.proveedorForm.get('calleReal').setValue(this.proveedorForm.get('calleFiscal').value);
    this.proveedorForm.get('nroCasaReal').setValue(this.proveedorForm.get('nroCasaFiscal').value);
    this.proveedorForm.get('dptoReal').setValue(this.proveedorForm.get('dptoFiscal').value);
    this.proveedorForm.get('pisoReal').setValue(this.proveedorForm.get('pisoFiscal').value);
    this.proveedorForm.get('barrioReal').setValue(this.proveedorForm.get('barrioFiscal').value);
    this.proveedorForm.get('ciudadReal').setValue(this.proveedorForm.get('ciudadFiscal').value);
    this.proveedorForm.get('codPostalReal').setValue(this.proveedorForm.get('codPostalFiscal').value);
    if (this.proveedorForm.get('provinciaFiscal').value != null) {
      this.proveedorForm.get('provinciaReal').setValue(this.proveedorForm.get('provinciaFiscal').value);
      this.proveedorForm.get('dptoProvincialReal').setValue(this.proveedorForm.get('dptoProvincialFiscal').value);
    }
    this.proveedorForm.get('telefonoReal').setValue(this.proveedorForm.get('telefonoFiscal').value);
    this.proveedorForm.get('celularReal').setValue(this.proveedorForm.get('celularFiscal').value);
  }

  resetearForm() {
    this.proveedorForm.reset();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addProveedor() {
   

    this.service.addProveedor(this.proveedorForm.value).subscribe(result =>{
      debugger;
         this.resultado = result;
         console.log(this.resultado);
         this.openSnackBar(this.resultado,'Cerrar');
    });
  }
}
